import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Content from '../../components/layout/Content';
import DeeplinkDetail from './deeplinks/DeeplinkDetail';
import DeeplinksEditor from './deeplinks/DeeplinksEditor';

const DeeplinksListPage = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex items-center gap-4 mb-6'>
                    <Button variant='ghost' size='icon' onClick={() => navigate('/cms')}>
                        <ArrowLeft className='h-4 w-4' />
                    </Button>
                    <div>
                        <h1 className='text-3xl font-bold'>Deeplinks</h1>
                        <p className='text-muted-foreground'>
                            Verwalten Sie Deeplinks mit Slug und zugeordneter buchbarer Leistung.
                        </p>
                    </div>
                </div>

                <DeeplinksEditor />
            </div>
        </Content>
    );
};

const DeeplinksCMS = () => {
    return (
        <Routes>
            <Route path='/' element={<DeeplinksListPage />} />
            <Route path='/:id' element={<DeeplinkDetail />} />
        </Routes>
    );
};

export default DeeplinksCMS;
